export default __webpack_public_path__ + "static/businessman-1ddd042e1351835953b58fd9d3b50375.svg";